import { HStack, Image, Link, Text, VStack } from '@chakra-ui/react';
import { MouseEvent } from 'react';
import { bbb, charityNavLogo } from '../../../assets';

export const Footer = () => {
  const handleOptOutClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,no-undef
    const window = globalThis as any;
    if (
      window?.OneTrust &&
      typeof window?.OneTrust?.ToggleInfoDisplay === 'function'
    ) {
      window.OneTrust.ToggleInfoDisplay();
    }
  };

  return (
    <VStack as="footer" align="left" spacing={6} py={6}>
      <HStack justify="center">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.give.org/charity-reviews/national/Other/ALSAC-St.-Jude-Childrens-Research-Hospital-in-Memphis-tn-2903"
        >
          <Image src={bbb} alt="Better Business Bureau logo" />
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.charitynavigator.org/index.cfm?bay=search.summary&amp;orgid=12847"
        >
          <Image
            style={{ marginTop: '8px' }}
            width="128px"
            src={charityNavLogo}
            alt="Charity Navigator logo"
          />
        </Link>
      </HStack>

      <Text>
        &copy; Copyright {new Date().getFullYear()} St. Jude Children&apos;s
        Research Hospital, a not-for-profit, section 501 (c)(3) corporation.
      </Text>

      <Text>
        St. Jude Children&apos;s Research Hospital / ALSAC, 501 St. Jude Place,
        Memphis, TN 38105 USA
      </Text>

      <HStack justify="start">
        <Text as={Link} href="mailto:donors@stjude.org">
          donors@stjude.org
        </Text>

        <Text
          as={Link}
          href="https://www.stjude.org/legal/u-s-privacy-policy-statement.html"
          target="_blank"
        >
          U.S. Privacy Notice
        </Text>
        <Link href="#" onClick={handleOptOutClick}>
          Your Opt-Out Rights
        </Link>
      </HStack>
    </VStack>
  );
};
